import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=0e50687a&scoped=true&"
import script from "./TemplateItem.vue?vue&type=script&lang=js&"
export * from "./TemplateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50687a",
  null
  
)

export default component.exports